import { ref } from 'vue'

/**
 * The prototype's toast, as three lines of state: one message, three seconds, bottom
 * right. Not a queue — a newer message replaces the old, exactly as the prototype's did.
 */
export const toastMessage = ref('')
export const toastShown = ref(false)

let timer = 0

export const toast = (message: string) => {
    toastMessage.value = message
    toastShown.value = true

    window.clearTimeout(timer)
    timer = window.setTimeout(() => { toastShown.value = false }, 3000)
}
